/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
import JSZip from 'jszip';
// TODO: try https://www.npmjs.com/package/unzipit ?
export class Zipper {
    binaryFormat;
    static forNodeJS() {
        return new Zipper('nodebuffer');
    }
    static forBrowser() {
        return new Zipper('blob');
    }
    constructor(binaryFormat) {
        this.binaryFormat = binaryFormat;
    }
    zipFiles(files) {
        const zip = new JSZip();
        files.forEach((file) => zip.file(file.path, file.content));
        return zip.generateAsync({ type: this.binaryFormat, compression: 'DEFLATE' });
    }
    async unzip(content) {
        const zip = new JSZip();
        await zip.loadAsync(content);
        const result = [];
        for (const name in zip.files) {
            const file = await zip.file(name)?.async(this.binaryFormat);
            // "name" can represent a directory
            if (file) {
                result.push({ path: name, content: file });
            }
        }
        return result;
    }
}
//# sourceMappingURL=Zipper.js.map